import { useState } from "react";
import { useParams } from "react-router-dom";
import { useStore } from "../lib/storeContext";
import { AssetImage } from "../components/AssetImage";
import { Lightbox } from "../components/Lightbox";
import type { LightboxSlide } from "../components/Lightbox";
import { Breadcrumbs, EmptyState, Spinner } from "./ui";
import { formatDate } from "../lib/util";
import type { IdeaPayload, RoomPayload } from "../lib/types";

export function IdeabookView() {
  const { roomId = "" } = useParams();
  const { store, rev, loading } = useStore();
  const [lightbox, setLightbox] = useState<number | null>(null);
  void rev;

  if (loading) return <Spinner />;
  const room = store.get<RoomPayload>("ROOM", roomId);
  const ideas = store.ideas(roomId);
  const slides: LightboxSlide[] = ideas.map((i) => ({
    s3Key: i.assets[0]?.s3Key ?? "",
    caption: (i.payload as IdeaPayload).goal,
  }));

  return (
    <div className="space-y-6">
      <Breadcrumbs
        items={[
          { label: "Projects", to: "/" },
          { label: room?.payload.name ?? "Room", to: `/rooms/${roomId}` },
          { label: "Ideabook" },
        ]}
      />
      <h1 className="text-2xl font-bold text-ink">Ideabook</h1>

      {ideas.length === 0 ? (
        <EmptyState
          icon="📖"
          title="Your Ideabook is empty"
          subtitle="Tap the heart on any AI design idea to save it here."
        />
      ) : (
        <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4">
          {ideas.map((idea, i) => (
            <div key={idea.id} className="card overflow-hidden">
              <AssetImage
                s3Key={idea.assets[0]?.s3Key}
                alt={(idea.payload as IdeaPayload).goal}
                className="aspect-square"
                onClick={() => setLightbox(i)}
              />
              <div className="p-3">
                <div className="line-clamp-2 text-sm font-medium text-ink">{(idea.payload as IdeaPayload).goal}</div>
                <div className="mt-1 text-xs text-muted">{formatDate((idea.payload as IdeaPayload).createdAt)}</div>
              </div>
            </div>
          ))}
        </div>
      )}

      {lightbox != null && (
        <Lightbox slides={slides} index={lightbox} onClose={() => setLightbox(null)} onIndexChange={setLightbox} />
      )}
    </div>
  );
}
